export const profile = {
  Profile: "프로필",
  ProfileDesc: "프로필 세부 정보를 보고 수정하세요.",
  ProfileImageDesc: "프로필 이미지를 변경하세요.",
} as const;
